/*
  Magic Wishlist theme glue.
  1) Product page: move the wishlist button next to Add to cart and paint it as a square stroke button that turns
     black on hover.
  2) Panels: give the drawer / modal / share overlays the same frosted white as the theme's other side panels.
  The app sets these colours with inline `!important` styles, which a stylesheet cannot beat, so they are applied from
  here with setProperty(..., 'important') and re-applied whenever the app rewrites them.
  3) Product page info column (desktop): one single scroll instead of two (see the end of this file).
*/
(function () {
  var WL = null;

  /* ---------- 1) product page button ---------- */
  function colours(hover) {
    if (hover) return ['#000000', '1px solid #000000', '#ffffff'];
    return ['#ffffff', '1px solid #e3e3e3', '#000000'];
  }

  function paint(btn) {
    var c = colours(btn.classList.contains('wl-hover'));
    var s = btn.style;
    if (
      s.getPropertyValue('background-color') === c[0] &&
      s.getPropertyValue('color') === c[2] &&
      s.getPropertyPriority('background-color') === 'important' &&
      s.getPropertyValue('border-radius') === '0px'
    ) {
      return;
    }
    s.setProperty('background-color', c[0], 'important');
    s.setProperty('border', c[1], 'important');
    s.setProperty('color', c[2], 'important');
    s.setProperty('border-radius', '0', 'important');
  }

  function bind(btn) {
    if (btn.__wlBound) return;
    btn.__wlBound = true;
    btn.addEventListener('mouseenter', function () { btn.classList.add('wl-hover'); paint(btn); });
    btn.addEventListener('mouseleave', function () { btn.classList.remove('wl-hover'); paint(btn); });
    new MutationObserver(function () { paint(btn); }).observe(btn, { attributes: true, attributeFilter: ['style'] });
  }

  function place() {
    var row = document.querySelector('.product__info-wrapper .product-form__buttons');
    if (!row) return;
    if (!WL) {
      WL = document.querySelector('.product__info-wrapper .wishlist-btn-container');
      if (!WL) return;
      var oldBlock = WL.closest('.product__block');
      if (oldBlock) oldBlock.classList.add('wishlist-block-moved');
    }
    var slot = row.querySelector('.wishlist-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'wishlist-slot';
      row.appendChild(slot);
    }
    if (WL.parentElement !== slot) slot.appendChild(WL);
    var btn = WL.querySelector('.wishlist-btn');
    if (btn) { bind(btn); paint(btn); }
  }

  /* ---------- 2) overlays ---------- */
  var OVERLAYS = '.wishlist-drawer__overlay, .wishlist-modal-overlay, .wishlist-share-modal__overlay, .wishlist-page-share-modal__overlay';

  function fixOverlay(el) {
    var s = el.style;
    if (s.getPropertyValue('background-color') === 'rgba(255, 255, 255, 0.55)' && s.getPropertyPriority('background-color') === 'important') return;
    s.setProperty('background-color', 'rgba(255, 255, 255, 0.55)', 'important');
    s.setProperty('-webkit-backdrop-filter', 'blur(3px)', 'important');
    s.setProperty('backdrop-filter', 'blur(3px)', 'important');
  }

  function scanOverlays() {
    var list = document.querySelectorAll(OVERLAYS);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      fixOverlay(el);
      if (!el.__wlOv) {
        el.__wlOv = true;
        new MutationObserver(function (m) { fixOverlay(m[0].target); }).observe(el, { attributes: true, attributeFilter: ['style'] });
      }
    }
  }

  /* ---------- 3) one scroll for the product page ---------- */
  /*
    The info column used to be pinned and scrolled on its own (a second scroll inside the page), so reaching its end
    felt stuck until the wheel / trackpad paused. Now it is a plain sticky column with no inner scroll: it moves with
    the page until its bottom edge is 20px above the bottom of the window, then stays pinned there while the photos
    keep scrolling, and is released at the end of the section. If the column is shorter than the window it keeps the
    theme's normal sticky top. Desktop only (990px and up); below that the theme's own layout is untouched.
  */
  var MQ = window.matchMedia('(min-width: 990px)');
  var infoRaf = 0;

  function updateInfoSticky() {
    infoRaf = 0;
    var ic = document.querySelector('.product__info-wrapper .product__info-container.sticky-element');
    if (!ic) return;
    ic.style.removeProperty('top');
    ic.style.removeProperty('max-height');
    ic.style.removeProperty('overflow-y');
    if (!MQ.matches) return;
    var orig = parseFloat(getComputedStyle(ic).top) || 0;
    var top = Math.min(orig, window.innerHeight - ic.scrollHeight - 20);
    ic.style.setProperty('max-height', 'none', 'important');
    ic.style.setProperty('overflow-y', 'visible', 'important');
    ic.style.setProperty('top', top + 'px', 'important');
  }

  function queueInfoSticky() {
    if (!infoRaf) infoRaf = requestAnimationFrame(updateInfoSticky);
  }

  function startInfoSticky() {
    var ic = document.querySelector('.product__info-wrapper .product__info-container.sticky-element');
    if (!ic) return;
    updateInfoSticky();
    if (!ic.__wlSticky) {
      ic.__wlSticky = true;
      if (window.ResizeObserver) new ResizeObserver(queueInfoSticky).observe(ic);
    }
  }
  window.addEventListener('resize', queueInfoSticky);
  window.addEventListener('load', queueInfoSticky);

  /* ---------- start ---------- */
  function start() {
    place();
    scanOverlays();
    startInfoSticky();
    var wrap = document.querySelector('.product__info-wrapper');
    if (wrap && !wrap.__wlObserved) {
      wrap.__wlObserved = true;
      new MutationObserver(function () { place(); }).observe(wrap, { childList: true, subtree: true });
    }
    if (!document.body.__wlOvObserved) {
      document.body.__wlOvObserved = true;
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = setTimeout(function () { t = null; scanOverlays(); }, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
